import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Navigation from '@/navigation/Navigation';
import { Provider } from 'react-redux';
import { persistor, store } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import './index.css';
import 'react-tooltip/dist/react-tooltip.css';
import NotificationProvider from './components/Notifications/NotificationProvider';
import { ConfirmProvider } from './components/Confirm/ConfirmProvider';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://4f457cfd85482ee701913cc780b7c84b@o495490.ingest.us.sentry.io/4511687411302400',
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  },
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Enable logs to be sent to Sentry
  enableLogs: true
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <NotificationProvider>
          <ConfirmProvider>
            {process.env.REACT_APP_ENVIRONMENT === 'dev' && (
              <div className="absolute top-0 right-0 z-50 bg-red-500 p-2 text-white opacity-40">
                <span className="font-bold">DEV</span> {process.env.REACT_APP_VERSION}
              </div>
            )}
            <Navigation />
          </ConfirmProvider>
        </NotificationProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// expose store when run in Cypress
if (window.Cypress) {
  window.store = store;
}

// TODO: Find a better way to expose store to Cypress

declare global {
  interface Window {
    Cypress: unknown;
    store?: typeof store;
  }
}
